export default __webpack_public_path__ + "static/premio-py-434f701eb56cb83354019427c8843c6f.png";